import $ from "jquery";

export class Infobox {

    constructor() {
        (<any>window).Infobox = this;

        $(document).ready(function () {
            (<any>window).Infobox.updateInfobox();
        });

        $(window).on("load", function () {
            (<any>window).Infobox.initInfoBox();
            (<any>window).Infobox.updateInfobox();
        });

        $(window).on("resize", function () {
            (<any>window).Infobox.updateInfobox();
        });

        $(window).on("scroll", function () {
            (<any>window).Infobox.updateInfobox();
        });
    }

    initInfoBox() {
        $(".infobox").css("display", "block");

        $(".infobox A.closex").click(function (e) {
            e.preventDefault();
            $(this).closest(".infobox").animate({ right: -400 }, {
                duration: 2200, complete: function () {
                    $(this).remove();
                }
            });
            $(this).closest(".infobox").parent().find(".infobox-background").animate({ right: -400 }, {
                duration: 2200, complete: function () {
                    $(this).remove();
                }
            });
        })

        return;
    }

    updateInfobox() {
        if ($(window).innerWidth() <= 760) {
            $(".infobox").css("bottom", "0px");
        } else {
            if ($(".slider").length > 0) {
                var toppi = $(window).innerHeight() - ($($(".slider")[0]).outerHeight() + $($(".slider")[0]).offset().top - $(window).scrollTop());
                if (toppi < 0) toppi = 0;
                $(".infobox").css("bottom", toppi);
            } else {
                $(".infobox").css("bottom", "0px");
            }
        }

        $(".infobox-background").css("bottom", $(".infobox").css("bottom"));
        $(".infobox-background").css("width", $(".infobox").outerWidth());
        $(".infobox-background").css("height", $(".infobox").outerHeight());
    }

}